import React, { createContext, useContext } from "react";

export const StatisticContext = createContext();

export const useStatisticContext = () => useContext(StatisticContext);

export const StatisticProvider = ({ children, value }) => (
  <StatisticContext.Provider value={value}>
    {children}
  </StatisticContext.Provider>
);
